import accounting from 'accounting-big'

// {{ amount | asAccounting('$') }}
export default (amount, currency = 'R', precision = 2, thousandsSeparator = ',', precisionSeparator = '.', format = '%s %v') => {
  return accounting.formatMoney(amount, currency, precision, thousandsSeparator, precisionSeparator, format)
}
